import React, { useEffect, useState } from "react";

// Popup on Initial Website load
/*
const provinces = [
  { "en": "Alberta", "fr": "Alberta" },
  { "en": "British Columbia", "fr": "Colombie-Britannique" },
  { "en": "Manitoba", "fr": "Manitoba" },
  { "en": "New Brunswick", "fr": "Nouveau-Brunswick" },
  { "en": "Newfoundland and Labrador", "fr": "Terre-Neuve-et-Labrador" },
  { "en": "Nova Scotia", "fr": "Nouvelle-Écosse" },
  { "en": "Ontario", "fr": "Ontario" },
  { "en": "Prince Edward Island", "fr": "Île-du-Prince-Édouard" },
  { "en": "Quebec", "fr": "Québec" },
  { "en": "Saskatchewan", "fr": "Saskatchewan" },
  { "en": "Northwest Territories", "fr": "Territoires du Nord-Ouest" },
  { "en": "Nunavut", "fr": "Nunavut" },
  { "en": "Yukon", "fr": "Yukon" }
];
*/

const LangModal = ({ onSubmit }) => {
  const [showModal, setShowModal] = useState(false);
  //const [province, setProvince] = useState("");
  const [consent, setConsent] = useState("");
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const storedPrefs = localStorage.getItem("preferredLanguage");
    if (!storedPrefs) {
      setShowModal(true);
    }
  }, []);

  const handleSave = () => {
    const prefs = { value: language, expiry: Date.now() + 7 * 24 * 60 * 60 * 1000 };
    localStorage.setItem('preferredLanguage', JSON.stringify(prefs));
    setShowModal(false);
    onSubmit(prefs);
  };

  if (!showModal) return null;

  return (
    <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'#0f0f0f99',zIndex:999999}} className="">
      <div style={{width:'fit-content',height:'fit-content',position:'absolute',left:'50%',top:'50%',transform:'translate(-50%,-50%)',textAlign:'center',borderRadius:'10px',background:'#fff',boxShadow:'0px 0px 15px 0px #CC4037',padding:'50px'}}>
        <h2 className="" style={{fontSize:'42px',lineHeight:'1.5',fontWeight:'bold',marginBottom:'30px'}}>Welcome to Travelance / Bienvenue chez Travelance</h2>

        {
          /*
          <div className="" style={{marginBottom:'30px'}}>
            <label className="" style={{display:'block','fontSize':'18px',margin:'0  0 10px 0',textAlign:'left'}}>Select your province / Sélectionnez votre province</label>
            <select value={province} onChange={(e) => setProvince(e.target.value)} className="" style={{width:'100%',padding:'10px',border:'1px solid',borderRadius:'3px'}}
            >
              <option value="">-- Select Province / Sélectionnez Province  --</option>
              {provinces.map((prov,i) => (
                <option key={`prov-${i}`} value={prov.en}>{`${prov.en} / ${prov.fr}`}</option>
              ))}
            </select>
          </div>

          */
        }



        <div className="" style={{marginBottom:'30px'}}>
          <label className="" style={{display:'block',fontSize:'18px',margin:'10px 10px 10px 0',textAlign:'left'}}>Select language / Sélectionnez la langue</label>
          <div className="" style={{display:'flex',justifyContent:'left'}}>
            <button className="" style={{margin:'0 5px 5px 0',padding:'10px 40px',borderRadius:'3px',background: language === "en" ? "#CC4037" : "#ffffff",color:language === "en" ? "#ffffff" : "#CC4037",border: "2px solid #CC4037" }} onClick={() => setLanguage("en")}>English</button>
            <button className="" style={{margin:'0 5px 5px 0',padding:'10px 40px',borderRadius:'3px',background: language === "fr" ? "#CC4037" : "#ffffff",color:language === "fr" ? "#ffffff" : "#CC4037",border: "2px solid #CC4037" }} onClick={() => setLanguage("fr")}>Français</button>
          </div>
        </div>

        <div className="" style={{marginBottom:'20px', textAlign:'left'}}>
          <label style={{display:'inline-block', alignItems:'center'}}>
          <input
            type="checkbox"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            style={{marginRight:'10px'}}
          />
          By accessing our website and checking this box, you agree to our <a style={{color:'#CC4037', textDecoration:'underline'}} href="/privacy-policy">Privacy Policy</a> and use of cookies. / En accédant à notre site Web et en cochant cette case, vous acceptez notre <a style={{color:'#CC4037', textDecoration:'underline'}} href="/politique-de-confidentialite" target="_blank" rel="noopener noreferrer">Politique de confidentialité</a> et l'utilisation de cookies.
          </label>
        </div>

        <button
          onClick={handleSave}
          disabled={!consent}
          style={{padding:'10px 40px',borderRadius:'3px',background:"#CC4037",color:"#ffffff",border: "2px solid #CC4037" }}
          className=""
        >
          Continue / Continuer
        </button>
      </div>
    </div>
  );
};

export default LangModal;
